let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4a6qd")).then(() => parcelRequire('kvLWR'));